import _cloneDeep from "lodash/cloneDeep";
import { StorageName } from "../../../constants/sdk";
import LoggingModule from "../../logging-module";
import BaseStorageWrapper, { DATA_TEMPLATE } from "./BaseStorageWrapper";
const INIT_CONSENT_STORE_DATA = {
  consentEntityValidationMap: {},
  [StorageName.USER_CONSENT]: _cloneDeep(DATA_TEMPLATE),
  [StorageName.DEVICE_CONSENT]: _cloneDeep(DATA_TEMPLATE),
  [StorageName.BOTH_CONSENT]: _cloneDeep(DATA_TEMPLATE)
};
const INIT_NOTIFICATION_STORE_DATA = {
  [StorageName.NOTIFICATION]: _cloneDeep(DATA_TEMPLATE)
};
class InMemStorageWrapper extends BaseStorageWrapper {
  constructor() {
    super("InMemStorageWrapper", true);
    this._updateUserInfo = (deviceId, userId) => {
      LoggingModule.info(`[${this.name}]: _updateUserInfo`, {
        userId,
        deviceId
      });
      this._did = deviceId;
      this._uid = userId;
    };
    this.insertConsentData = (data, timestamp, userInfo) => {
      LoggingModule.info(`[${this.name}]: insertConsentData`, {
        data,
        timestamp,
        userInfo
      });
      try {
        this.insertDataIntoStore(data, timestamp, userInfo);
      } catch (error) {
        LoggingModule.error(`[${this.name}]: insert - ${error.message}`, error);
      }
    };
    this.insertNotificationData = (data, timestamp, userInfo) => {
      LoggingModule.info(`[${this.name}]: insertNotificationData`, {
        data,
        timestamp,
        userInfo
      });
      try {
        const store = this.getNotificationStore(userInfo);
        this.insertDataByStorageName(store, StorageName.NOTIFICATION, data, timestamp);
      } catch (error) {
        LoggingModule.error(`[${this.name}]: insert - ${error.message}`, error);
      }
    };
    this.getConsentStore = (userInfo) => {
      this._cleanUpUnrelatedUserData(userInfo);
      return this._consentStore;
    };
    this.getNotificationStore = (userInfo) => {
      return this._notificationStore;
    };
    this._cleanUpUnrelatedUserData = (userInfo) => {
      const { device_id: deviceId = "", user_id: userId = "" } = userInfo != null ? userInfo : {};
      if (deviceId !== this._did) {
        this._consentStore[StorageName.DEVICE_CONSENT] = _cloneDeep(DATA_TEMPLATE);
        this._consentStore[StorageName.BOTH_CONSENT] = _cloneDeep(DATA_TEMPLATE);
      }
      if (userId !== this._uid) {
        this._consentStore[StorageName.USER_CONSENT] = _cloneDeep(DATA_TEMPLATE);
        this._consentStore[StorageName.BOTH_CONSENT] = _cloneDeep(DATA_TEMPLATE);
      }
      this._updateUserInfo(deviceId, userId);
    };
    this.cleanConsentData = () => {
      this._consentStore.consentEntityValidationMap = {};
      this._consentStore[StorageName.USER_CONSENT] = _cloneDeep(DATA_TEMPLATE);
      this._consentStore[StorageName.DEVICE_CONSENT] = _cloneDeep(DATA_TEMPLATE);
      this._consentStore[StorageName.BOTH_CONSENT] = _cloneDeep(DATA_TEMPLATE);
    };
    this.cleanNotificationData = () => {
      this._notificationStore[StorageName.NOTIFICATION] = _cloneDeep(DATA_TEMPLATE);
    };
    this.clean = () => {
      this._consentStore = _cloneDeep(INIT_CONSENT_STORE_DATA);
      this._notificationStore = _cloneDeep(INIT_NOTIFICATION_STORE_DATA);
    };
    this.destruct = () => {
      this.clean();
    };
    this.clean();
  }
}
var InMemStorageWrapper_default = InMemStorageWrapper;
export {
  InMemStorageWrapper_default as default
};
